export const validation = {
  partNumber: 'Part number is required',
  partCost: 'Part cost is required',
  customerTag: 'Customer tag is required',
  jobTag: 'Job tag is required',
  max10:'Please enter role name less than 10 characters'
};
